export default __webpack_public_path__ + "static/media/textSortIconLight.c63af0b4.svg";